import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchInstance } from 'modules/app';
import AppComponents from '../components';

const mapStateToProps = state => ({
  router: state.router,
  app: state.app,
});

function mapDispatchToProps(dispatch) {
  return {
    fetchInstance: bindActionCreators(fetchInstance, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppComponents);



// WEBPACK FOOTER //
// ./src/routes/Embed/App/container/index.js